import { createContext, type ReactNode, useContext, useState } from "react";
import type { ChatbotAttachableQuestion } from "src/components/GlobalChatbot/types";

interface ChatbotContextType {
	attachableQuestion?: ChatbotAttachableQuestion;
	attachedQuestion: ChatbotAttachableQuestion | null;
	attachQuestion: () => void;
	removeAttachedQuestion: () => void;
}

const ChatbotContext = createContext<ChatbotContextType>({
	attachedQuestion: null,
	attachQuestion: () => {},
	removeAttachedQuestion: () => {},
});

interface ChatbotProviderProps {
	attachableQuestion?: ChatbotAttachableQuestion;
	children: ReactNode;
}

export const ChatbotProvider = ({
	attachableQuestion,
	children,
}: ChatbotProviderProps) => {
	const [attachedQuestion, setAttachedQuestion] =
		useState<ChatbotAttachableQuestion | null>(null);
	const [seenQuestionId, setSeenQuestionId] = useState(attachableQuestion?.id);

	// Inne pytanie na stronie = stary attachment już nieaktualny.
	if (attachableQuestion?.id !== seenQuestionId) {
		setSeenQuestionId(attachableQuestion?.id);
		setAttachedQuestion(null);
	}

	return (
		<ChatbotContext.Provider
			value={{
				attachableQuestion,
				attachedQuestion,
				attachQuestion: () => setAttachedQuestion(attachableQuestion ?? null),
				removeAttachedQuestion: () => setAttachedQuestion(null),
			}}
		>
			{children}
		</ChatbotContext.Provider>
	);
};

export const useChatbotContext = () => useContext(ChatbotContext);
